
/**
 * Extracts error message from API error response
 * Handles format: { errors: ["message1", "message2"] }
 */
function extractApiErrorMessage(response: unknown): string | null {
  try {
    if (!response || typeof response !== 'object') {
      return null;
    }

    const errorResponse = response as any;

    // Handle { errors: [...] } format
    if (Array.isArray(errorResponse.errors) && errorResponse.errors.length > 0) {
      // Join multiple errors with line breaks
      return errorResponse.errors.join('\n');
    }

    // Handle { error: "message" } format
    if (typeof errorResponse.error === 'string') {
      return errorResponse.error;
    }

    // Handle { message: "message" } format
    if (typeof errorResponse.message === 'string') {
      return errorResponse.message;
    }

    return null;
  } catch (err) {
    console.error('Error extracting API error message:', err);
    return null;
  }
}

/**
 * Error class for API errors
 */
export class ApiError extends Error {
  public apiMessage: string | null;

  constructor(
    message: string,
    public statusCode?: number,
    public response?: unknown
  ) {
    super(message);
    this.name = 'ApiError';
    this.apiMessage = extractApiErrorMessage(response);
  }
}

